module.exports = __webpack_public_path__ + "img/ye.dc0bba07.svg";